angular.module('trainerWebApp.controllers')
  .controller('GetStarted2Ctrl', ['$scope', '$location', 'uploadSvc', '$timeout', 'trackingService', 'mtypes', 'actionLogResource', function ($scope, $location, uploadSvc, $timeout, trackingService, mtypes, actionLogResource) {
//If they've already made it thru GS, keep them in the app
//    if (mfConfig.appLoadingStarted)
//      return $location.path('/TMS/Home');
    var gaActions = trackingService.pages.getStarted.actions;

    var distractionTextIdx = 0;
    var distractionTexts = [
      "Creating course.",
      "Creating course..",
      "Creating course..."
    ];

    var view = $scope.view = {
      percent: 0,
      state: 'ready',
      files: [],
      uploader: null,
      filter: [
        {title: 'Content', extensions: mfConfig.upload.fileTypes.replace(/\*\./g, '').replace(/;/g, ',') }
      ]
    };
    var uploadToken;

    $scope.goToTrainerHome = function () {
      trackGS(gaActions.GettingStarted_SkipToHome);
      $location.path("/TMS/Home");
    };

    $scope.onFilesAdded = function () {
      if (!view.uploader) return;

      trackGS(gaActions.GettingStarted_FindFile);
      trackingService.trackKissMetricsEvent("clicked on", {
        action: "clicked upload file on GS"
      });
      view.state = 'uploading';

      _.each(view.files, function (file, idx) {
        if (idx > 0)
          view.uploader.removeFile(file);
      });

      uploadToken = Date.now() + '_' + Math.random();     //Predictably random

      view.uploader.settings.url = '/TrainerGS/upload';
      view.uploader.settings.multipart_params = {
        uploadToken: uploadToken,
        sessId: mfConfig.sessionId
      };
      view.uploader.start();
      loadFlexApp();
      view.uploader.disableBrowse(true);
    };

    $scope.onFilesUploaded = function () {
      if (!view.uploader) return;
      view.state = 'uploaded';
      distractionTextIdx = 0;
      serveDistrationText();

      view.files = [];
      _.each(view.files, function (file) {
        view.uploader.removeFile(file);
      });

      uploadSvc.startConvert({uploadToken: uploadToken}).then(function (result) {
        if(result.success)
          return $location.path('/TMS/Course_Dashboard/' + result.courseID);

        view.uploader.init();
        view.percent = 0;
        view.state = 'ready';
        view.errorMessage = result.errorMessage || "Mindflash can't upload this file because it appears to be corrupt.";
      });
    };

    function serveDistrationText() {
      var txt = distractionTexts[distractionTextIdx % distractionTexts.length];
      if (!txt) return;
      view.distractionText = txt;
      distractionTextIdx++;
      $timeout(serveDistrationText, 1000);
    }

    function trackGS(eventName) {
      trackingService.trackEvent(trackingService.pages.getStarted.name, eventName);
    }
    function loadFlexApp() {
      if (mfConfig.appLoadingStarted) return;

      MF.loadAppSwf();
    }

    var findZendeskWidgetPromise = null;
    var zendeskWidget = null;
    function findZendeskWidget() {
      findZendeskWidgetPromise = $timeout(function () {
        zendeskWidget = angular.element('#launcher');
        if (!zendeskWidget || zendeskWidget.length == 0)
          return findZendeskWidget();
        zendeskWidget.css('visibility', 'hidden');
        $timeout.cancel(findZendeskWidgetPromise);
      }, 250);
    }

    var findIntercomWidgetPromise = null;
    var intercomWidget = null;
    function findIntercomWidget() {
      findIntercomWidgetPromise = $timeout(function () {
        intercomWidget = angular.element('#intercom-container');
        if (!intercomWidget || intercomWidget.length == 0)
          return findIntercomWidget();
        intercomWidget.css('display', 'inline');
        $timeout.cancel(findIntercomWidgetPromise);
      })
    }

    $scope.$on('$destroy', function () {
      $timeout.cancel(findZendeskWidgetPromise);
      $timeout.cancel(findIntercomWidgetPromise);
      if (zendeskWidget)
        zendeskWidget.css('visibility', 'visible');
      if (intercomWidget)
        intercomWidget.css('display', 'none');
    });

    trackGS(gaActions.GettingStarted);
    actionLogResource.writeActionLog([{action: mtypes.actionType.getStarted}]);
    findZendeskWidget();
    findIntercomWidget();
  }]);
